// src/components/ui/TestimonialCarousel.tsx
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
import Carousel from './Carousel';
import TestimonialCard from './TestimonialCard';
import { testimonials } from '../../data/testimonials';
import { fadeInUp } from '../../utils/animations';

const TestimonialCarousel: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const groupedTestimonials = [];
  for (let i = 0; i < testimonials.length; i += 2) {
    groupedTestimonials.push(testimonials.slice(i, i + 2));
  }

  return (
    <div className="relative">
      {/* Decorative elements */}
      <div className="absolute -top-10 -left-10 w-20 h-20 bg-mauve-100 rounded-full opacity-50"></div>
      <div className="absolute -bottom-10 -right-10 w-32 h-32 bg-mauve-100 rounded-full opacity-30"></div>
      
      {/* Carousel */}
      <Carousel
        autoPlay={true}
        interval={8000}
        showControls={true}
        showDots={true}
        showArrows={true}
        className="py-8"
      >
        {groupedTestimonials.map((group, groupIndex) => (
          <div key={groupIndex} className="space-y-6">
            {group.map((testimonial, index) => (
              <motion.div
                key={testimonial.id}
                initial="initial"
                animate="animate"
                variants={fadeInUp}
                transition={{ delay: index * 0.1 }}
              >
                <TestimonialCard testimonial={testimonial} />
              </motion.div>
            ))}
          </div>
        ))}
      </Carousel>

      {/* Rating Summary */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
        className="mt-12 bg-gradient-to-r from-mauve-50 to-mauve-100 rounded-2xl p-8 border border-mauve-200"
      >
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start mb-2">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  size={24}
                  className="fill-mauve-500 text-mauve-500 mx-0.5"
                />
              ))}
            </div>
            <h3 className="text-2xl font-bold text-mauve-900">
              Rated 4.9/5 by Accra Clients
            </h3>
          </div>
          
          <div className="text-center">
            <div className="text-4xl font-bold text-mauve-900 mb-1">500+</div>
            <div className="text-mauve-700">Happy Clients Served</div>
          </div>
          
          <div className="text-center">
            <div className="text-4xl font-bold text-mauve-900 mb-1">98%</div>
            <div className="text-mauve-700">Repeat Business Rate</div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default TestimonialCarousel;